/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, jsx } from 'theme-ui'
import CallToAction from '~/components/Content/Section/CallToAction'

const PressCard = ({ press }) => {
  const { cta, logo, longQuote } = press

  return (
    <Flex sx={{ flexDirection: 'column', height: '100%' }}>
      {logo && (
        <Flex
          bg="white"
          sx={{
            alignItems: 'center',
            borderRadius: '8px 8px 0 0',
            height: '100px',
            justifyContent: 'center',
          }}
        >
          <GatsbyImage image={logo.gatsbyImageData} alt={logo.description} />
        </Flex>
      )}
      <Box
        bg="backgroundLight"
        px={[4, 3, 4]}
        pt={2}
        pb={3}
        sx={{ borderRadius: '0 0 8px 8px', flexGrow: '1' }}
      >
        {longQuote && (
          <Box
            variant="text.body2"
            dangerouslySetInnerHTML={{
              __html: longQuote.childMarkdownRemark.html,
            }}
            sx={{
              p: {
                my: 2,
              },
            }}
          />
        )}
        {cta && (
          <Box mt={2}>
            <CallToAction content={cta} type="text" />
          </Box>
        )}
      </Box>
    </Flex>
  )
}

export default PressCard
